// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SvgAngle[data-v-90775ebc]{display:inline-flex;justify-content:center;align-items:center;vertical-align:middle}.SvgAngle__svg[data-v-90775ebc]{width:1em;height:1em}", ""]);
// Exports
module.exports = exports;
